module.exports = __webpack_public_path__ + "media/mypage/images/special/interviews-98e18213cba5bf15782ab3769f0650dd.png";